import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { fetchCategories } from '../../../api/categories';
import { useAuth } from '../../auth/AuthProvider';
import { ActionInput } from '../../common/ActionInput';
import { ActionSelect } from '../../common/ActionSelect';
import styles from './styles.module.scss';

export const ServiceTableFilter = () => {
  const [filterParams, setFilterParams] = useSearchParams();
  const [categories, setCategories] = useState<{ label: string; value: string }[]>([]);
  const { signOut } = useAuth();
  const { showToast } = useToast();
  const updateFilterParams = (key: string, value: string) => {
    const newParams = new URLSearchParams(filterParams);
    if (value) {
      newParams.set(key, value);
    } else {
      newParams.delete(key);
    }
    setFilterParams(newParams);
  };

  useEffect(() => {
    const getCategories = async () => {
      try {
        const categories = await fetchCategories(signOut);
        setCategories([
          ...categories.categories.map(category => ({
            label: category.name,
            value: category.code,
          })),
        ]);
      } catch {
        showToast({ message: 'データの取得に失敗しました。', status: 'danger' });
      }
    };
    if (categories.length === 0) {
      getCategories();
    }
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.form}>
        <label htmlFor='title' className={styles.formTitle}>
          サービス名
        </label>
        <ActionInput
          id='title'
          defaultValue={filterParams.get('title')}
          action={e => updateFilterParams('title', e.target.value)}
          placeholder='家事代行サービス'
        />
      </div>
      <div className={styles.form}>
        <label htmlFor='category[code]' className={styles.formTitle}>
          カテゴリー
        </label>
        <ActionSelect
          items={categories}
          value={filterParams.get('category[code]')}
          onChange={e => updateFilterParams('category[code]', String(e))}
          defaultValue={filterParams.get('category[code]')}
          noSelect={true}
        />
      </div>
    </div>
  );
};
